import { type SubmissionQuotaType, type SubmissionQuotaWindow } from "../../gql-generated/types";

export enum SubmissionQuotaContext {
    Regular = "regular",
    LensPlus = "lensPlus",
}

export enum SubmissionQuotaSeverity {
    Normal = "normal",
    Warning = "warning",
    Urgent = "urgent",
    Exhausted = "exhausted",
}

export interface SubmissionQuota {
    remaining: number;
    remainingPercentage: number;
    limitingQuotaType: SubmissionQuotaType;
    limitingWindow: SubmissionQuotaWindow;
    replenishAt: Date | null;
    severity: SubmissionQuotaSeverity;
}

export interface SubmissionQuotas {
    regular: SubmissionQuota | null;
    lensPlus: SubmissionQuota | null;
}
